import { parseServerObjectToFormattedString } from '@innovyze/lib_am_common/Utils';
import { useTzDateTime } from '@innovyze/stylovyze';
import { ExpectedStringType } from '@Types';

export function useDateFormatter() {
	const formatDateUTC = useTzDateTime({ timeZone: 'UTC' }).formatDate;
	return (value: string | undefined) =>
		parseServerObjectToFormattedString(
			value,
			ExpectedStringType.Date,
			formatDateUTC,
		) || '-';
}
